import axiosClient from './axiosClient';
import { urlApiCampaign } from '~/utils/constants/apis';
import {
  ICampaign,
  ICampaignDetail,
  IFormCampaign,
  IQueryParamCampaign,
  IQueryUpdateCampaign,
} from '~/utils/interface/campaign';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';

const campaignApi = {
  getListCampaign: (params: IQueryParamCampaign) => {
    const url = urlApiCampaign.getListCampaign;
    return axiosClient.get<IBaseResponse<IListDataResponse<ICampaign[]>>>(url, { params });
  },

  deleteCampaign: (campaignId: string) => {
    const url = urlApiCampaign.deleteCampaign(campaignId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  createCampaign: (body: IFormCampaign) => {
    const url = urlApiCampaign.createCampaign;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  getDetailCampaign: (campaignId: string) => {
    const url = urlApiCampaign.getDetailCampaign(campaignId);
    return axiosClient.get<IBaseResponse<ICampaignDetail>>(url);
  },

  updateCampaign: ({ campaignId, body }: IQueryUpdateCampaign) => {
    const url = urlApiCampaign.updateCampaign(campaignId);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default campaignApi;
